// extracted by mini-css-extract-plugin
export default {"label":"label_label__J22AD","required":"label_required__kbVzq"};